// extracted by mini-css-extract-plugin
export default {"container":"AdvertisingPage_container__C65M2"};